import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { TemplateDetail } from '@/api/hooks/useAttestations';

interface PublishResult {
  template: TemplateDetail;
  version: { id: string; version_number: number; is_current: boolean };
}

export function useTemplatePublish(templateId: string, tenantId: string) {
  const qc = useQueryClient();
  return useMutation<PublishResult, Error>({
    mutationFn: async () => {
      const { data } = await apiClient.patch<{ data: PublishResult }>(
        `/assessment-templates/${templateId}/publish`,
        {},
      );
      return data.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['assessment-template', templateId] });
      qc.invalidateQueries({ queryKey: ['assessment-templates', tenantId] });
      qc.invalidateQueries({ queryKey: ['template-versions', templateId] });
    },
  });
}
